<template>
  <div
    v-if="visible"
    class="gif-modal-overlay"
  >

    <div class="gif-modal-container">

      <button
        class="gif-modal-close"
        type="button"
        aria-label="Cerrar"
        @click="cerrarModal"
      >
        &times;
      </button>

      <img
        src="/gif/aviso.gif"
        alt="Información"
        class="gif-modal-image"
      />

    </div>

  </div>
</template>

<script>
export default {
  name: "GifModal",

  data() {
    return {
      visible: true,
    };
  },

  mounted() {
    document.body.style.overflow = "hidden";

    document.addEventListener(
      "keydown",
      this.cerrarConEscape
    );
  },

  beforeUnmount() {
    document.body.style.overflow = "";

    document.removeEventListener(
      "keydown",
      this.cerrarConEscape
    );
  },

  methods: {
    cerrarModal() {
      this.visible = false;

      document.body.style.overflow = "";
    },

    cerrarConEscape(event) {
      if (event.key === "Escape") {
        this.cerrarModal();
      }
    },
  },
};
</script>

<style scoped>
.gif-modal-overlay {
  position: fixed;

  inset: 0;

  z-index: 999999;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 20px;

  background: rgba(0, 0, 0, 0.75);
}

.gif-modal-container {
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  max-width: 95vw;
  max-height: 95vh;
}

.gif-modal-image {
  display: block;

  max-width: 100%;
  max-height: 90vh;

  width: auto;
  height: auto;

  border-radius: 8px;
}

.gif-modal-close {
  position: absolute;

  top: -17px;
  right: -17px;

  z-index: 10;

  width: 44px;
  height: 44px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0;

  border: none;
  border-radius: 50%;

  background: #ffffff;

  color: #222222;

  font-size: 32px;
  line-height: 1;

  cursor: pointer;

  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.4);
}

.gif-modal-close:hover {
  background: #eeeeee;
}

@media (max-width: 768px) {
  .gif-modal-overlay {
    padding: 12px;
  }

  .gif-modal-image {
    max-height: 85vh;
  }

  .gif-modal-close {
    top: -12px;
    right: -5px;

    width: 40px;
    height: 40px;

    font-size: 28px;
  }
}
</style>